import React, { Component } from "react";
import { Form, Row, Col } from "reactstrap";
import FormComponent from "../../../common/FormComponent";
import {
  Validator,
  submitValidator,
  refresh,
  valid,
} from "../../../common/Validator";
import { withRouter } from "react-router-dom";

import Notifier from "../../aside/Notifier";
import ErrorNotifier from "../../aside/ErrorNotifier";
import axios from "axios";
import { API_CANDIDATE,RS_API } from "../../../utils/config";
import Button from "@material-ui/core/Button";

import SelectGovtId from "./selectGovtId"

// import { KeyboardReturnTwoTone } from "@material-ui/icons";

/**
 * Updatepersonal detail Component for updating the personal details.
 */

 var isIdvalid = true
class UpdatePersonalDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
    
      id:  this.props.updateData
      ? this.props.updateData.id
      : "",
     idproofNo:"",
     noOfYears: this.props.updateData
     ? this.props.updateData.yearOfExp
     : 0,
     firstName: this.props.updateData
     ? this.props.updateData.firstName
     : "",
     lastName: this.props.updateData
     ? this.props.updateData.lastName
     : "",
     dob: this.props.updateData
     ? this.props.updateData.dob
     : "",
     eMailId:this.props.getMail?this.props.getMail:"",
     country: this.props.updateData
     ? this.props.updateData.country
     : "",
     gender: this.props.updateData
     ? this.props.updateData.gender
     : "",
     location: this.props.updateData
     ? this.props.updateData.location
     : "",
     mobileNo: this.props.updateData
     ? this.props.updateData.mobileNo
     : "",
 
     experienceType:this.props.updateData
     ? this.props.updateData.experienceType
     : "",
      message: "",
      dateError: "",
      error: "",
      errorYear:"",
      idName:"",
      servingError: "",
      govtProof:[],
      idError:""
    };
    this.onChange = this.onChange.bind(this);
  
    this.onUpdate = this.onUpdate.bind(this);
 
    this.idProof = this.idProof.bind(this)
    this.handleGovtNameChange = this.handleGovtNameChange.bind(this)
  }

  onChange(e) {
   Validator(e.target);
    this.setState({
      [e.target.name]: e.target.value,
    });
   
  }

 

//  onupdate function by clcking update button
  onUpdate(e) {
 e.preventDefault();
    submitValidator(e.target);
   if(!this.state.idName){
   this.setState({
     idError:"This field is mandatory"
   })
   isIdvalid = true
   }
   else{
    this.setState({
      idError:""
    })
    isIdvalid = false

   }

  let datePart =this.state.dob.split('-')
    let date = new Date(datePart[0], datePart[1],datePart[2] )

    let data = {
      id: this.state.id,
      firstName: this.state.firstName,
      lastName:  this.state.lastName,
      dob:  date,
      eMailId:this.state.eMailId,
      country:this.state.country,
      gender: this.state.gender,
      location: this.state.location,
      mobileNo: Number(this.state.mobileNo),
  
      experienceType: this.state.experienceType,
      yearOfExp:Number(this.state.noOfYears),
      govtIdProofName:this.state.idName,
      govtIdProofNos:this.state.idProofNo
    
    };
    if (valid && !isIdvalid ) {
      axios
        .put(`${API_CANDIDATE}/v1/api/create-user`, data, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res);
          if (res.data.ok) {
            this.setState({
              message: "Updated successfully ",
            });
          }
          setTimeout(() => {
            this.setState({
              message: "",
            });
            this.props.back();
          }, 2000);
        })
        .catch((err) => {
          this.setState({
            error: err.message,
          });
          setTimeout(() => {
            this.setState({
              error: "",
            });
          }, 2000);
        });
    } 
    else {
      this.setState({
        error: "Enter all mandatory fields",
      });
      setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  }



  
//  get government id proof from rs
 idProof (){
  axios.get(`${RS_API}/v1/api/can-gov-id-name/can`,{withCredentials:true}).then((res)=>{
    console.log(res.data)
  this.setState({
    govtProof:res.data
  })
  

  }).catch((err)=>{

  })
 }

//  onchange function handling govt name change

 handleGovtNameChange(e){
 this.setState({
   idName:e.target.value,
   idError:""
 })
 }

 

  componentDidMount() {
    this.idProof()

    refresh();
    this.setState({
      message: "",
      error: "",
    });
  }

  render() {
    console.log(this.state.workingDay);
    const {
     idProofNo,
   
      message,
      error,
    } = this.state;

    return (
      <>
        <div style={{ paddingLeft: "2.5rem" }}>
          <i
            className="material-icons cancel-button pointer"
            onClick={this.props.isOpen}
          >
            cancel
          </i>
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "24px",
                fontWeight: "bold",
                paddingTop: "0.5rem",
              }}
            >
              <span> Update Personal Detail</span>
            </div>
            <div>
              <Form onSubmit={this.onUpdate} className="p-3" noValidate>
                <Row>
                  <Col>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <span style={{fontWeight:"bold"}}>Proof Name</span>
                       < SelectGovtId
                      widthValue="600px"
                      value={this.state.idName}
                    
                      onChange={this.handleGovtNameChange}
                   
                      dataarr={this.state.govtProof}
                    />
                     {this.state.idError && (
                    <span style={{fontSize: 15, color: "red"}} className="error ">
                      
                      {this.state.idError}
                    </span>
                  )}
                    </div>
                   

                      <FormComponent
                        style={{
                          height: "50px",
                          marginTop: "10px",
                          width: "600px",
                        }}
                        labelClass="bold label-sm"
                        label="Id Proof No."
                        type="textarea"
                        name="idProofNo"
                        inputClass="form-control-sm"
                        value={idProofNo}
                        change={this.onChange}
                        required={true}
                        minlength="2"
                        maxlength="60"
                      />

                   
                    </div>
                  </Col>
                </Row>

                <div className="center">
                  <Button
                    type="submit"
                    style={{
                      background: "#0984e3",
                      marginTop: "30px",
                      color: "white",
                    }}
                    className="btn login-button white-text"
                  >
                    Submit
                  </Button>
                </div>
              </Form>

              {message && <Notifier message={message} />}
              {error && <ErrorNotifier message={error} />}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(UpdatePersonalDetail);
